import { CategoryInfo } from "../../components/filtered/types"
import kids from "../../assets/local_categories/children.png"
import culture from "../../assets/local_categories/culture.png"
import education from "../../assets/local_categories/education.png"
import games from "../../assets/local_categories/games.png"
import love from "../../assets/local_categories/love.png"
import parties from "../../assets/local_categories/party.png"
import sport from "../../assets/local_categories/sport.png"
import tourism from "../../assets/local_categories/tourism.png"
import walks from "../../assets/local_categories/walking.png"
import concerts from "../../assets/local_categories/concerts.png"
import { useGetAllCategoriesQuery } from "../../app/data/category/categoryApi"
import { useAppSelector } from "../../app/hooks";
import { selectCategories, selectLoading } from "../../shared/categories/selectors";

// Локальные картинки по id категории
const LOCAL_IMAGES: Record<number, string> = {
  17: games,
  15: love,
  4: parties,
  5: education,
  16: culture,
  20: concerts, // Концерты и фестивали
  1: sport,
  13: walks,
  12: tourism,
  7: kids,
}

// Порядок категорий на сайте.
// «Нетворкинг» ещё не имеет постоянного id — ставим его первым по названию (см. orderIndex).
// Любовь — в середине списка.
// 20 = Концерты и фестивали (стоит сразу после Игр и Вечеринок)
// Порядок под ЦА 20-32 лет Москва: концерты и игры первыми, детское/религия в конце
export const CATEGORY_ORDER: number[] = [20, 17, 4, 1, 5, 13, 15, 8, 16, 2, 12, 7, 14, 9, 19]
export const NETWORKING_TITLE = "Нетворкинг"

// Скрытые категории: сервер их присылает, но показывать пока не нужно.
// 18 — Шопинг (0 событий). Чтобы вернуть, достаточно убрать id отсюда.
export const HIDDEN_CATEGORY_IDS: number[] = [18]
export const isCategoryVisible = (id: number) => !HIDDEN_CATEGORY_IDS.includes(id)

// Позиция категории в списке: Нетворкинг всегда первый, дальше по CATEGORY_ORDER
export const categoryOrderIndex = (id: number, title?: string) => {
  if (title && title.trim().toLowerCase() === NETWORKING_TITLE.toLowerCase()) return -1
  const i = CATEGORY_ORDER.indexOf(id)
  return i === -1 ? 999 : i
}

export type CategoriesState = {
  categories: CategoryInfo[]
  isLoading: boolean
}

export const useCategoryProvider = (): CategoriesState => {
  useGetAllCategoriesQuery()
  const isLoading = useAppSelector(selectLoading)
  const categoriesFromServer = useAppSelector(selectCategories)

  // Заменяем URL с сервера на локальные картинки где есть
  const withLocalImages = (categoriesFromServer || [])
    .filter((c) => isCategoryVisible(c.id))
    .map((c) => {
      // Для Нетворкинга пока временная картинка — пока не нарисуем свою в стиле остальных
      const isNetworking = c.title?.trim().toLowerCase() === NETWORKING_TITLE.toLowerCase()
      const local = LOCAL_IMAGES[c.id] || (isNetworking ? education : undefined)
      return { ...c, url: local || c.url, srcset: local || c.srcset }
    })

  const sorted = [...withLocalImages].sort(
    (a, b) => categoryOrderIndex(a.id, a.title) - categoryOrderIndex(b.id, b.title)
  )

  // Если API не вернул категории — используем локальный фолбэк
  if (!categoriesFromServer || categoriesFromServer.length === 0) {
    return {
      categories: CATEGORY_ORDER.map((id, priority) => ({
        id,
        title: LOCAL_TITLES[id] || String(id),
        priority,
        url: LOCAL_IMAGES[id] || games,
        srcset: LOCAL_IMAGES[id] || games,
      })),
      isLoading,
    }
  }

  return { categories: sorted, isLoading }
}

const LOCAL_TITLES: Record<number, string> = {
  17: "Игры",
  15: "Любовь",
  4: "Вечеринки",
  5: "Обучение",
  16: "Культура",
  20: "Концерты и фестивали",
  1: "Спорт",
  13: "Прогулки",
  12: "Туризм",
  7: "Для детей",
  18: "Шопинг",
  9: "Религия",
  14: "Для животных",
  8: "Отдых за городом",
  2: "Поездки",
  19: "Другое",
}
